import Checkbox from "./checkbox";
import CheckboxGroup from "./Group";

Checkbox.Group = CheckboxGroup;

export default Checkbox;



// WEBPACK FOOTER //
// ./_antd1.11.2/checkbox/index.jsx